export const downloadImage = (imageUrl: string) => {
  window.open(encodeURI(imageUrl), "_blank")
}
